export const environment = {
    production: true,
    URL_API: 'https://enexdirecto.enex.cl/',
    horas_PedidosHome: 72,
    STORAGE_SECRET_KEY: '==!En3xUsu4R1oS!%&·',
    idPromotor: 11583,
    cantidadResultadoPorPagina: [5,10,15,20,50],
    horaCorteNuevoPedido: '1800',
    googleCaptchaSiteKey: "6LeT_r0ZAAAAAHRCLQasHx3P-Ni5os-bmhvw8aDC",
    googleCaptchaSecretKey: "6LeT_r0ZAAAAANCdRKndPKwOsaZ5hQnQoj4Sr3Wd",
    googleAnalyticsId: "UA-132460606-1",
    //googleAnalyticsId: "291028989"
    facturacion:{
      activaAbonos:true,
      activaAbonosParciales:true
    }
};
